import React from "react";
import styled from "styled-components";
import { ExternalLink } from "../ExternalLink";
import { mobileQuery } from "../MediaQuery";
import { MyOverflowSlider } from "../MySlider";
import { SizedBox } from "../SizedBox";
import { language, translation } from "../translations";
import { Header2, Paragraph1 } from "../typography";
import { HomeSection } from "./HomeSection";

interface Article {
  image: string;
  previewEn: string;
  previewPl: string;
  url?: string;
}

const articles: Array<Article> = [
  {
    image: "ptmsz.png",
    previewEn:
      "The lifestyle improvements of Vika app users are impressive. The scientific approach combined with the game-like features delivers great results.",
    previewPl:
      "Wyniki poprawy stylu życia u użytkowników aplikacji Vika są imponujące. Naukowe podejście połączone z grą daje bardzo dobre rezultaty.",
    url: undefined,
  },
  {
    image: "polskie-radio.png",
    previewEn:
      "It is the world's first model embedded in an app, created thanks to an artificial neural network that helps check and take care of health in the times of a pandemic.",
    previewPl:
      "Jest to pierwszy na świecie model aplikacji stworzonej dzięki sztucznej sieci neuronowej, która pomaga sprawdzić i odzyskać formę oraz zadbać o zdrowie w czasach pandemii.",
    url: "https://www.polskieradio.pl/7/161/Artykul/2653011,Asystent-zdrowego-stylu-zycia-Pomoze-w-walce-ze-skutkami-pandemii",
  },
  {
    image: "wyborcza.png",
    previewEn:
      "An ongoing lifestyle assessment is essential. Importantly, Vika not only makes predictions but also leads by hand in changing lifestyle.",
    previewPl:
      "Bieżąca ocena stylu życia to podstawa. Co ważne, Vika nie tylko prognozuje, ale i prowadzi za rękę w zmianie stylu życia.",
    url: "https://trojmiasto.wyborcza.pl/trojmiasto/7,35612,26651605,polscy-naukowcy-udostepniaja-pierwszy-na-swiecie-model-zdrowego.html",
  },
  {
    image: "trojmiasto.png",
    previewEn:
      "For nearly two years, doctors and scientists from Tricity have been working on the health model that the application is based on, and the new, anonymised statistical data will allow for its further improvement.",
    previewPl:
      "Trójmiejscy lekarze i naukowcy pracują już blisko dwa lata nad modelem zdrowotnym, na którym opiera się aplikacja, a nowe, zanonimizowane dane statystyczne pozwolą na dalsze jego udoskonalanie.",
    url: "https://nauka.trojmiasto.pl/Aplikacja-podpowie-jak-dbac-o-zdrowie-by-zyc-dluzej-Stworzyli-ja-programisci-i-lekarze-z-Trojmiasta-n151955.html",
  },
  {
    image: "ojcowska-strona-mocy.png",
    previewEn:
      "As I was surprised at the beginning by things like making the bed, Vika in a smooth manner leads you by saying to start with small things, and bigger things will come soon, and in that way, we are improving our character.",
    previewPl:
      "Jak na początku zaskoczyły mnie takie rzeczy jak ścielenie łóżka to tak naprawdę, Vika fajnie prowadzi w ten sposób, że mówi, żeby zacząć od małych rzeczy, większe rzeczy przyjdą za chwilę, także rozbudowujemy swoją postać.",
    url: "https://www.ojcowskastronamocy.pl/czy-wiesz-ile-zdrowia-przed-toba-jak-drobne-zmiany-stylu-zycia-wydluzaja-nasze-zdrowie-lukasz-osowski-osm-podcast-066/",
  },
  {
    image: "sztuczna-inteligencja.png",
    previewEn:
      "Here's an app that will evaluate how you live, how much longer you could live like this - and will tell you what you should do to live longer and better. Scientifically, with no fake.",
    previewPl:
      "Oto aplikacja, która oceni, jak żyjesz, ile tak jeszcze pociągniesz – i podpowie, co powinieneś zrobić, by pożyć dłużej i lepiej. Naukowo, bez ściemy.",
    url: "https://www.sztucznainteligencja.org.pl/vika-przepowie-ci-przyszlosc-w-zdrowiu-i-chorobie/",
  },
  {
    image: "pfr.png",
    previewEn:
      "When selecting the winners, the jury decided primarily based on the quality of the app, the app's business preparation and potential to fight the crisis.",
    previewPl:
      "Dokonując wyboru laureatów jury kierowało się głównie jakością aplikacji, jej przygotowaniem biznesowym i potencjałem do walki z kryzysem.",
    url: "https://mediapfr.prowly.com/119369-6-innowacyjnych-rozwiazan-do-walki-z-pandemia-powstanie-dzieki-wsparciu-pfr",
  },
];

export const ArticlesSection: React.FC = () => (
  <HomeSection gradient>
    <Layout>
      <Title>{translation.articlesAboutUs}</Title>

      <SizedBox desktopHeight={32} mobileHeight={24} />

      <MyOverflowSlider>
        {articles.map((article, i) => {
          const preview =
            language === "pl" ? article.previewPl : article.previewEn;

          return (
            <ArticleBox
              key={`article-${i}`}
              image={article.image}
              preview={preview}
              url={article.url}
            />
          );
        })}
      </MyOverflowSlider>

      <SizedBox desktopHeight={32} mobileHeight={16} />
    </Layout>
  </HomeSection>
);

const ArticleBox: React.FC<{
  image: string;
  preview: string;
  url?: string;
}> = (props) => (
  <ArticleBoxWrapper>
    <ArticleImage src={`/home/articles/${props.image}`} alt="" />
    <SizedBox height={16} />
    <Paragraph1 color="white">{props.preview}</Paragraph1>
    <SizedBox height={24} />
    {props.url != undefined && (
      <ReadMore href={props.url}>{translation.readMore}</ReadMore>
    )}
  </ArticleBoxWrapper>
);

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled(Header2)`
  color: white;
  ${mobileQuery`
    text-align: center;
  `}
`;

const ArticleImage = styled.img`
  width: 280px;
  height: 128px;
  object-fit: contain;
  max-width: 100%;
`;

const ReadMore = styled(ExternalLink)`
  color: white;
  display: block;
  text-align: right;
`;

const ArticleBoxWrapper = styled.div`
  display: inline-block;
  width: 380px;
  ${mobileQuery`
    width: 250px;
  `}
`;
